<div style="padding: 20px;">
  <h2 mat-dialog-title style="margin:0;">Retirar tudo</h2>

  <div mat-dialog-content style="overflow: inherit;">
    <div class="header-row">
      <div class="caps">
        <div class="line">
          <span class="label">Disponível:</span>
          <span class="val">{{ formatBRL(data.availableForWithdrawal) }}</span>
        </div>
        <div class="line">
          <span class="label">Saque mínimo:</span>
          <span class="val">{{ formatBRL(data.minWithdrawalAmount) }}</span>
        </div>
      </div>
    </div>

    <div class="form-grid" *ngIf="!isLoading; else loadingTpl">
      <p class="note">
        Você vai retirar <strong>{{ formatBRL(data.availableForWithdrawal) }}</strong> (todo o saldo disponível)
        para a sua chave PIX.
      </p>

      <mat-form-field appearance="outline" class="field">
        <mat-label>Chave PIX</mat-label>
        <input matInput [(ngModel)]="pix" placeholder="email, cpf/cnpj, telefone ou aleatória" />
        <mat-error *ngIf="!pix || pix.trim().length < 3">Informe uma chave PIX válida</mat-error>
      </mat-form-field>

      <div *ngIf="errorMsg" class="error-box">{{ errorMsg }}</div>
    </div>

    <ng-template #loadingTpl>
      <div class="loading">Processando...</div>
    </ng-template>
  </div>

  <mat-dialog-actions class="action-buttons">
    <button class="back-btn" (click)="close()">Cancelar</button>
    <button class="continue-btn" (click)="save()" [disabled]="!canConfirm()">Solicitar</button>
  </mat-dialog-actions>
</div>
